import { useState } from 'react';
import { getId } from 'utils/getId';
import { v4 as uuidv4 } from 'uuid';

// Get sessionId synchronously to avoid race conditions with event logging
const getSessionId = (): string => {
  try {
    return getId(sessionStorage, 'sessionId');
  } catch (e) {
    // If sessionStorage is unavailable (e.g., some privacy modes),
    // generate a temporary sessionId
    return uuidv4();
  }
};

const useSession = () => {
  // Initialize with the actual sessionId immediately (synchronous)
  const [sessionId] = useState<string>(() => getSessionId());

  return sessionId;
};

export default useSession;
